import { render, staticRenderFns } from "./GivBack.vue?vue&type=template&id=09355b33&scoped=true"
import script from "./GivBack.vue?vue&type=script&lang=js"
export * from "./GivBack.vue?vue&type=script&lang=js"
import style0 from "./GivBack.vue?vue&type=style&index=0&id=09355b33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09355b33",
  null
  
)

export default component.exports